import { z } from 'zod';
import { requiredString } from '../../../../validation';

export const InterimSummaryExpertSummarySchema = z.object({
  motivation: requiredString('Motivation and programme engagement is required'),
});

export type InterimSummaryExpertSummary = z.infer<
  typeof InterimSummaryExpertSummarySchema
>;
